import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    log:false,

    root_api:process.env.VUE_APP_ROOT_API,


    _cfg:{
      dias:15,
      dias_min:[],
      dias_max:[],
    },

    login:false,
    _session:{
      login:false,
      toke:"",
      idUsr:"",
      tipoUsr:3, //2 Viajante  3 Admin
      ComboBox:"v-select",
    },

    menuPpal:{
      drawer: false,
      title:{text:"", ico:"",class:""},
      items:[]
    },

    dataSite:{
      title:process.env.VUE_APP_TITLE,
      logo: false,
      class:"font-weight-medium title",
      link:""
    },

    alert:false,



  },
  getters: {
  //computeds
    ROOT_API (state) {
      return state.root_api
    },

    CFG (state){
      return state["_cfg"]
    },

    SESSION (state) {
      return state["_session"]
    },

    ALERT (state) {
      return state.alert
    },


    
    dataSite (state){
      return state.dataSite
    }




  },
  mutations: {
  //methods sincronos  
    setSession (state,val){
      let s=state["_session"]
      s.login=v.login
      s.toke=v.token,
      s.idUsr=v.isUsr,
      s.tipoUsr=v.tipoUsr
      s.ComboBox=b.ComboBox
    },

    logOut (state){
      localStorage.clear()
      state._session=undefined
    }


    //state._session=undefined
  },
  actions: {
    //methods asincronos
  },
  modules: {
  },
})
